const state = () => ({
    bonuses: 0,
    orders: [],
    info: {
        id: 0,
        phone: '',
        name: '',
        email: '',
        birthday: '',
        addresses: [],
        external_id: null
    },
    authorize: false,
    votes: [],
    isOrderHistoryLoaded: false,
    bonusHistory: [],
    isBonusHistoryLoaded: false,
})

// getters
const getters = {
    getBonuses: (state) => {
        return state.bonuses;
    },
    getInfo: (state) => {
        return state.info;
    },
    getVotes: (state) => {
        return state.votes;
    },
    isAuthorize: (state) => {
        return state.authorize;
    },
    getAddresses: (state) => {
        return state.addresses;
    },
    getEmail: (state) => {
        return state.info.email;
    },
    getOrderHistory: (state) => {
        return state.orders;
    },
    getOrderHistoryLoaded: (state) => {
        return state.isOrderHistoryLoaded;
    },
    getExternalId: (state) => {
        return state.info.external_id;
    },
    getBonusHistory: (state) => {
        return state.bonusHistory;
    },
    isBonusHistoryLoaded: (state) => {
        return state.isBonusHistoryLoaded;
    },
}

// actions
const actions = {
    setVote({commit}, {productVote}) {
        commit('setProductVote', productVote);
    },
    setUserInfo({commit}, {user}) {
        commit('setUserInfo', user);
    },
}

// mutations
const mutations = {
    setProductVote(state, {product_id, vote,}) {
        product_id = parseInt(product_id);
        if(vote === 1){
            const userVote = state.votes.find(id => id === product_id);
            if(userVote === undefined){
                state.votes.push(product_id);
            }
        }else{
            state.votes = state.votes.filter(id => id !== product_id);
        }
    },

    setUserInfo(state, user) {
        Object.assign(state.info, user);
        state.authorize = true;
        if(user.bonus !== undefined){
            state.bonuses = user.bonus;
        }
        if(user.votes !== undefined && user.votes.length){
            state.votes = user.votes;
        }
    },

    setOrderHistory(state, order) {
        state.isOrderHistoryLoaded = true;
        if(order !== undefined && order.length){
            state.orders = order;
        }
    },

    changeUserInfo(state, user){
        Object.assign(state.info, user);
    },

    removeAddress(state, address_id){
        state.info.addresses = state.info.addresses.filter(address => parseInt(address.id) !== parseInt(address_id));
    },

    logout(state){
        state.authorize = false;
    },

    setIsBonusHistoryLoaded(state){
        state.isBonusHistoryLoaded = true;
    },

    setBonusHistory(state, bonusHistory){
        state.bonusHistory = bonusHistory;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
